import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum'
import { User } from '@datadog/browser-rum-core/cjs/rawRumEvent.types'

import { useGetSessionUser } from '../api/useGetSessionUser'
import { version } from '../../package.json'
import { getAppConfigSetting } from '.'

const datadogConfig: RumInitConfiguration = {
  version,
  ...getAppConfigSetting('datadog')
}

export const startRum = () => {
  datadogRum.init(datadogConfig)
}

interface RumUser extends User {
  loginType?: string
}

export const useSetRumUser = (enabled: boolean) => {
  const hasRumUser = !!window.localStorage.getItem('rumUser')
  const { data } = useGetSessionUser(enabled && !hasRumUser)

  if (data) {
    const {
      userId: id,
      login: email,
      _links: {
        user: { name }
      }
    } = data

    const rumUser: RumUser = {
      ...(id && { id }),
      ...(email && { email }),
      ...(name && { name }),
      loginType: 'okta'
    }

    setRumUser(rumUser)
  } else {
    updateRumUser()
  }
}

export const setRumUser = (user: RumUser) => {
  window.localStorage.setItem('rumUser', JSON.stringify(user))
  datadogRum.setUser(user)
}

export const updateRumUser = () => {
  datadogRum.setUser(getRumUser())
}

const getRumUser = (): RumUser => {
  const rumUser = window.localStorage.getItem('rumUser')
  return rumUser ? JSON.parse(rumUser) : {}
}

export const clearRumUser = () => {
  window.localStorage.removeItem('rumUser')
}
